import { useEffect, useRef, useState } from "react";

const ChevronDown = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 9l6 6 6-6" />
    </svg>
);

// Dropdown simple (sin buscador) con el mismo estilo visual que SearchSelect —
// pensado para listas cortas y fijas de opciones (options: [{ value, label }]).
export const SimpleSelect = ({ options = [], value, onChange, placeholder = "Seleccione una opción" }) => {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    const selectedOption = options.find((opt) => String(opt.value) === String(value));

    useEffect(() => {
        const handler = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const handleSelect = (val) => {
        onChange(val);
        setOpen(false);
    };

    return (
        <div className={"lead-select" + (open ? " lead-select--open" : "")} ref={containerRef}>
            <button
                type="button"
                className="lead-select__trigger"
                onClick={() => setOpen((o) => !o)}
            >
                <span className={value ? "" : "lead-select__placeholder"}>
                    {selectedOption ? selectedOption.label : placeholder}
                </span>
                <ChevronDown />
            </button>

            {open && (
                <div className="lead-select__dropdown">
                    <div className="lead-select__list">
                        {options.map((opt) => (
                            <div
                                key={opt.value}
                                className={
                                    "lead-select__option" +
                                    (String(opt.value) === String(value) ? " lead-select__option--selected" : "")
                                }
                                onClick={() => handleSelect(opt.value)}
                            >
                                {opt.label}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SimpleSelect;
